module.exports = require("socket.io-msgpack-parser");